import { logDataToConsole, logError } from "../../utils/customLogger";

export const getIcdDescription = async (
  icdCode: string,
  signal?: AbortSignal,
): Promise<string> => {
  try {
    const response = await fetch(
      `https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms=${icdCode}&count=100`,
      { signal },
    );

    if (!response.ok) {
      return "--";
    }

    const data = await response.json();

    if (!data || data.length === 0) {
      return "--";
    }

    const [, , , icd_with_description] = data;
    logDataToConsole("icd_with_description", icd_with_description);
    return icd_with_description?.[0]?.[1] ?? "--";
  } catch (error) {
    if ((error as Error).name === "AbortError") {
      return "";
    }
    logError(error as Error);
    return "--";
  }
};

export const getIcdCodes = async (icdCode: string): Promise<[]> => {
  try {
    const response = await fetch(
      `https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms=${icdCode}&count=100`,
    );

    if (!response.ok) {
      return [];
    }

    const data = await response.json();

    if (!data || data.length === 0) {
      return [];
    }

    const [, , , icd_code] = data;
    const icdCodes = icd_code.map((code: string[]) => {
      return {
        label: code,
        value: code,
      };
    });

    return icdCodes ?? [];
  } catch (error) {
    logError(error as Error);
    return [];
  }
};
